module.exports = __webpack_public_path__ + "static/img/news1.75988f0d.jpg";